/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useContext, useState} from "react";
import {Link} from "react-router-dom";
import TableHeader from "../../Common/TableHeader";
import ActivationsSearchForm from "../../Common/Statistics/ActivationsSearchForm";
import SchoolContext from "../../../Context/SchoolContext";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import Loader from "../../Common/Loader";
import Pagination from "../../Common/Pagination";

function ReplacementsList() {

    const {schoolList} = useContext(SchoolContext);
    const [query, setQuery] = useState("");
    const [school, setSchool] = useState("");
    const [startDate, setStartDate] = useState("");

    const [endDate, setEndDate] = useState("");
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);

    const [meta, setMeta] = useState([]);
    const [replacements, setReplacements] = useState([]);

    useEffect(() => {
        if (query || school || startDate || endDate) {
            searchReplacements();
        } else {
            getReplacements(page);
        }
    }, [page]);
  
    const getReplacements = async (currentPage) => {
        setLoading(true);
        const server_response = await ajaxStudent.listAllReplacements(currentPage);
        setLoading(false);
        if (server_response.status === "OK") {
            setMeta(server_response.details.meta.totalPages);
            setReplacements(server_response.details.data || []);
        } else {
            setReplacements([]);
        }
    };

    const searchReplacements = async (e) => {
        if (e) {
            e.preventDefault();
        }
        setLoading2(true);
        const server_response = await ajaxStudent.searchReplacements(page,school,query,startDate,endDate);
        setLoading2(false);
        if (server_response.status === "OK") {
            setMeta(server_response.details.meta.totalPages);
            setReplacements(server_response.details.data || []);
        } else {
            setReplacements([]);
        } 
    };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  const setReplacement = (e) => {
    e.preventDefault();
    setQuery("");
    setSchool("");
    setStartDate("");
    setEndDate("");
    setPage(1);
    getReplacements(1);
    
  };


  return (
    <div className="col-lg-12 col-md-12 mt-3">
              <div className="card height-auto">
                <div className="card-body">
                <div class="heading-layout1 mg-b-5">
        <TableHeader
          title = "Replacements / Swaps List"
          subtitle="List of all the card and wristband swaps or replacements sorted by the most recent"    
        />
        <div class="dropdown">
          <Link class="dropdown-toggle" role="button" data-toggle="dropdown" aria-expanded="false">...</Link>
          <div class="dropdown-menu dropdown-menu-right">
            <Link class="dropdown-item" onClick={setReplacement}> <i class="fas fa-redo-alt text-orange-peel"></i>Refresh</Link>
          </div>
        </div>
      </div>

      <ActivationsSearchForm school={school} student={query} setSchool={setSchool} setStudent={setQuery} startDate={startDate}
      endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} searchActivations={searchReplacements}
      setPage={setPage} resetSearch={setReplacement} schoolList={schoolList}/>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
      {loading || loading2 ? (
        <Loader />
                      ) : (
        <table className="table display data-table text-nowrap">
            <thead>
                <tr>
                <th scope="col">Date</th>
                <th scope="col">Student Name</th>
                <th scope="col"> School</th>
                <th scope="col"> Replacement Type</th>
                </tr>
            </thead>
            <tbody>
                {replacements.length > 0 ? (
                    replacements.map((item, index) => (
                    <tr key={index}>
                        

                        <td>
                        {item.created_at?.short_date}
                        <br />
                      <small>
                      {item.created_at?.time}
                      </small>
                        </td>
                        
                        <td>
                            {item.last_name} {item.first_name}
                            <br />
                            <small>{item.username}</small>
                        </td>
                        <td>{item.school_name}</td>
                        <td>{item.account_id ==="11"?<span class="badge badge-info">CARD</span>:<span class="badge badge-wb">WRISTBAND</span>}</td>

                    </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="4" style={{ textAlign: "center" }}>
                            No swaps or replacements yet.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
      )}
        
      </div>
      <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
                </div>
              </div>
          </div>
  );
}

export default ReplacementsList;
